<template>
    <div class="">
        <v-app-bar app light>
            <v-app-bar-nav-icon @click.stop="toggleDrawer"></v-app-bar-nav-icon>

            <v-toolbar-title
                class="text-uppercase black--text"
                style="background-color: white !important"
            ></v-toolbar-title>

            <v-spacer></v-spacer>
            <TicketButton></TicketButton>

            <!-- Icono de notificaciones -->
            <v-menu
                offset-y
                left
                :close-on-content-click="false"
                v-model="showNotifications"
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                        <v-badge
                            :content="notifications.length"
                            :value="notifications.length"
                            color="error"
                            overlap
                        >
                            <v-icon>mdi-bell</v-icon>
                        </v-badge>
                    </v-btn>
                </template>
                <v-card style="min-width: 300px; max-width: 350px">
                    <v-list subheader>
                        <v-subheader>Formaciones caducadas</v-subheader>

                        <v-list-item v-if="notifications.length === 0">
                            <v-list-item-content>
                                <v-list-item-title
                                    class="text-center grey--text"
                                >
                                    No hay notificaciones
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-for="(noti, idx) in notifications"
                            :key="idx"
                        >
                            <v-list-item-content>
                                <v-list-item-title>{{
                                    noti.nombre
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{
                                    noti.observaciones
                                }}</v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <router-link
                                        :to="`guardar-usuario?id=${noti.user.id}`"
                                    >
                                        <strong>Empleado:</strong>
                                        {{ noti.user.name }}
                                    </router-link>
                                </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                                <v-chip color="error" small class="mb-2">{{
                                    noti.fecha | format_date
                                }}</v-chip>
                                <v-btn
                                    icon
                                    x-small
                                    @click.stop="dismissNotification(noti)"
                                >
                                    <v-icon small>mdi-close</v-icon>
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-menu>

            <!-- Logo comentado temporalmente hasta tener el de Electrotecnia Inelco -->
            <!-- <img
                class="d-none d-sm-flex"
                height="30px"
                :src="rol != 13 ? 'logo.png' : 'logo_show.jpg'"
            /> -->

            <!--div class="text-center">
                <v-btn
                    @click="comprobarFichaje(false)"
                    icon
                    style="margin-right=5px;"
                >
                    <v-icon large>mdi-account-card-details-outline</v-icon>
                </v-btn>
            </div-->

            <v-btn @click="doLogout" icon>
                <v-icon>mdi-login-variant</v-icon>
            </v-btn>
        </v-app-bar>
    </div>
</template>

<script>
import TicketButton from "./TicketButton.vue";
import auth from "../../auth/auth.js";
export default {
    components: {
        TicketButton,
    },
    data() {
        return {
            showNotifications: false,
            // notifications: [], // Aquí se cargarán las notificaciones
        };
    },
    methods: {
        dismissNotification(notification) {
            // Remover la notificación del store
            this.$store.commit("remove_formacion_expired", notification.id);
        },
        comprobarFichaje(status) {
            //console.log(status);
            const url = status
                ? `api/comprobar-fichaje/true`
                : `api/comprobar-fichaje`;
            //console.log(url);
            axios.get(url).then(
                (res) => {
                    this.$toast.sucs("Fichaje realizado con éxito");
                },
                (res) => {
                    if (res.response.status == 301) {
                        return this.$emit("open");
                    }
                    this.$toast.error("Error realizando el fichaje");
                }
            );
        },
        toggleDrawer() {
            this.$emit("toggleDrawer");
        },
        doLogout() {
            auth.logout();
        },
    },
    computed: {
        rol() {
            return localStorage.getItem("role");
        },
        countPost: function () {
            return this.$store.getters.getPostCount;
        },
        notifications() {
            return this.$store.getters.getFormacionesExpired;
        },
    },
};
</script>
<style media="screen">
.theme--light.v-app-bar.v-toolbar.v-sheet {
    background-color: #ffffff !important;
}
</style>
